import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { OrderOutput } from 'core/http/project';
import { ownedError } from 'core/utils/owned-error';

@Component({
  selector: 'app-order-dates',
  templateUrl: './order-dates.component.html',
  styleUrls: ['./order-dates.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class OrderDatesComponent {
  private _order?: OrderOutput;

  @Input() skeletonView = false;

  @Input()
  set order(o: OrderOutput) {
    this._order = o;
  }

  get order(): OrderOutput {
    if (!this._order) {
      throw ownedError(new Error('Order is not initialized'));
    }

    return this._order;
  }
}
